module.exports = __webpack_public_path__ + "img/empty_card.ff55adf7.png";